import React from "react";
import "./Css/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">

      <div className="privacy-container">

        <h1 className="privacy-title">Privacy Policy</h1>

        <p>
          At <strong>Akes</strong>, accessible from
          <a href="https://akessoft.in" target="_blank" rel="noopener noreferrer">
            {" "}https://akessoft.in/
          </a>,
          we value your privacy and are committed to protecting your personal information.
        </p>

        <h2>Information We Collect:</h2>
        <ul>
          <li>Name, email, contact number, and shipping address</li>
          <li>Payment details (processed securely through payment gateways)</li>
          <li>Browsing and purchase history</li>
        </ul>

        <h2>How We Use It:</h2>
        <ul>
          <li>To process your orders</li>
          <li>To communicate updates about your purchases</li>
          <li>To improve your user experience and product offerings</li>
        </ul>

        <h2>Data Protection:</h2>
        <p>
          We do not sell, trade, or rent your personal information.
          All sensitive data is encrypted and transmitted securely.
        </p>

        <div className="privacy-contact">
          <h3>For any queries, contact us at:</h3>
          <p>📧 akessoftware@gmail.com</p>
        </div>

      </div>

    </div>
  );
};

export default PrivacyPolicy;